var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('nice-tabs',[_c('tab-base',{attrs:{"data-ni_tab_name":"Base"}}),_c('tab-cell-name',{attrs:{"data-ni_tab_name":"Cell Name"}}),_c('tab-cell-status',{attrs:{"data-ni_tab_name":"Cell Status"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }